import React from 'react'
export const ApiEndpoints = {
  autor: {
    authorList: "api/authors",
    authorCreate: "api/author/store",
    authorEdit: "api/author/edit/",
    authorUpdate: "api/author/update",
    authorDelete: "api/author/delete",
  },
  clientLogo: {
    List: "api/logos",
    Create: "api/logo/store",
    Edit: "api/logo/edit/",
    Update: "api/logo/update",
    Delete: "api/logo/delete",
  },
  sitemap: {
    view: "api/sitemap",
    update: "api/sitemap/update",
    List: "api/sitemap",
    Create: "api/sitemap/store",
    Edit: "api/sitemap/edit/",
    Update: "api/sitemap/update",
    Delete: "api/sitemap/delete",
  },
  tags: {
    tagList: "api/tags",
    tagCreate: "api/tag/store",
    tagEdit: "api/tag/edit/",
    tagUpdate: "api/tag/update",
    tagDelete: "api/tag/delete",
  },
  adminBlogs: {
    blogList: "api/blogs",
    blogCreate: "api/blogs/store",
    blogEdit: "api/blog/edit/",
    blogUpdate: "api/blog/update/",
    blogDelete: "api/blog/delete",
  }, 
  AIBlogs: {
    AIBlogList: "api/aiblogs",
    AIBlogCreate: "api/aiblogs/store",
    AIBlogEdit: "api/aiblog/edit/",
    AIBlogUpdate: "api/aiblog/update/",
    AIBlogDelete: "api/aiblog/delete",
  },
  category: {
    categoryList: "api/blog-categories",
    categoryCreate: "api/blog-category/store",
    categoryEdit: "api/blog-category/edit/",
    categoryUpdate: "api/blog-category/update",
    categoryDelete: "api/blog-category/delete",
  },
  seo: {
    seoList: "api/seo",
    seoCreate: "api/seo/store",
    seoEdit: "api/seo/edit/",
    seoUpdate: "api/seo/update",
    seoDelete: "api/seo/delete",
    seoByUrl: 'api/seo-by-url'
  },
  llms: {
    view: "api/llms",
    update: "api/llms/update",
  },
  robots: {
    view: "api/robots",
    update: "api/robots/update",
  },
  schema: {
    schemaView: "api/schema",
    schemaUpdate: "api/schema/update",
  },
  faq: {
    faqList: "api/faqs",
    faqCreate: "api/faq/store",
    faqEdit: "api/faq/edit/",
    faqUpdate: "api/faq/update",
    faqDelete: "api/faq/delete",
    faqByUrl: "api/faq-by-url",
  },
  featurePage: {
    featurePageList: "api/feature-pages",
    featurePageCreate: "api/feature-page/store",
    featurePageEdit: "api/feature-page/edit/",
    featurePageUpdate: "api/feature-page/update",
    featurePageDelete: "api/feature-page/delete",
  },
  
  feature: {
    featureList: "api/features",
    featureCreate: "api/feature/store",
    featureEdit: "api/feature/edit/",
    featureUpdate: "api/feature/update",
  },
  blogs: {
    blogList: "api/blogs",
    blogDetail: "api/blog/view/",
  },
  AIBlogsFront: {
    AIBlogList: "api/aiblogs",
    AIBlogDetail: "api/aiblog/view/",
  },
  contact: {
    contactCreate: "api/contact/store/",
    contactList: "api/contact/view"
  },
  caseCategory:{
    caseCategoryList: "api/casestudy-categories",
    caseCategoryCreate: "api/casestudy-category/store",
    caseCategoryEdit: "api/casestudy-category/edit/",
    caseCategoryUpdate: "api/casestudy-category/update",
    caseCategoryDelete: "api/casestudy-category/delete",
  },
  adminCase:{
    adminCaseList: "api/casestudys",
    adminCaseCreate: "api/casestudys/store",
    adminCaseEdit: "api/casestudy/edit/",
    adminCaseUpdate: "api/casestudy/update/",
    adminCaseDelete: "api/casestudy/delete",
    caseStudyDetail:"api/casestudy/view/",
  },
  newCase:{
    adminCaseList: "api/new-casestudys",
    adminCaseCreate: "api/new-casestudy/store",
    adminCaseEdit: "api/new-casestudy/edit/",
    adminCaseUpdate: "api/new-casestudy/update/",
    adminCaseDelete: "api/new-casestudy/delete",
    caseStudyDetail:"api/new-casestudy/view/",
  },
  adminMedia:{
    adminMediaList: "api/medias",
    adminMediaCreate: "api/media/store",
    adminMediaEdit: "api/media/edit/",
    adminMediaUpdate: "api/media/update/",
    adminMediaDelete: "api/media/delete",
  },
  CloneApp:{
    cloneAppCreate: "api/cloneapp/store",
    cloneAppView: "api/cloneapp/view",
    cloneAppDelete:"api/cloneapp/delete",
    cloneAppUpdate:"api/cloneapp/update",
  },
  VideoTestimonial:{
    testimonialCreate: "api/video-testimonial/store",
    testimonialView: "api/video-testimonials",
    testimonialEdit: "api/video-testimonials/",
    testimonialDelete:"api/video-testimonial/delete",
    testimonialUpdate:"api/video-testimonial/update",
  },
  dynamicEmail: {
    list: "api/dynamic-emails",
    create: "api/dynamic-email/store",
    edit: "api/dynamic-email/edit/",
    update: "api/dynamic-email/update",
    delete: "api/dynamic-email/delete",
  },
  rbac: {
    myPermissions: "api/rbac/my-permissions",
    userList: "api/rbac/users",
    userCreate: "api/rbac/user/store",
    userEdit: "api/rbac/user/edit/",
    userUpdate: "api/rbac/user/update/",
    userDelete: "api/rbac/user/delete",
    roleList: "api/rbac/roles",
    roleCreate: "api/rbac/role/store",
    roleEdit: "api/rbac/role/edit/",
    roleUpdate: "api/rbac/role/update/",
    roleDelete: "api/rbac/role/delete",
    permissionList: "api/rbac/permissions",
    permissionCreate: "api/rbac/permission/store",
    permissionEdit: "api/rbac/permission/edit/",
    permissionUpdate: "api/rbac/permission/update/",
    permissionDelete: "api/rbac/permission/delete",
  },
};
